import React, { useCallback, useEffect } from "react";
import { useLangContext } from "@layouts/home/LangContext";
import { VisitQuestionnaireAnswer } from "@pages/ecoa/visit/VisitQuestionnaire";
import { CrfSingleSelectItemSpec } from "maven-lib/dist/consts/edc";
import { EcoaQuestionnaire } from "maven-lib/dist/dto/entity/ecoaVisit";
import { HbHorizontalSelect } from "@maven-surface/components/base/HbHorizontalSelect";

interface QuestionnaireHorizonSelectItemProps {
  disabled?: boolean;
  isAvailable?: boolean;
  questionnaire: EcoaQuestionnaire;
  item: CrfSingleSelectItemSpec;
  defaultItemValues?: Array<VisitQuestionnaireAnswer>;
  onValueChange: (values: Array<VisitQuestionnaireAnswer>) => void;
}

export function QuestionnaireHorizontalSelectItem({
  item,
  defaultItemValues,
  disabled,
  isAvailable = true,
  onValueChange,
}: QuestionnaireHorizonSelectItemProps) {
  const { fontSize } = useLangContext();
  const dbVal = (defaultItemValues || []).find((e) => e.itemId === item.id)?.dbVal ?? null;

  const handleChangeValue = useCallback(
    (value: string | number | null, calcVal?: string | number | null) => {
      onValueChange([{ itemId: item.id, dbVal: value, calcVal: calcVal }]);
    },
    [item.id, onValueChange]
  );

  useEffect(() => {
    if (!isAvailable && defaultItemValues?.length && dbVal !== null && !item.ecoa?.noSkipWhenDisabled) {
      handleChangeValue(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAvailable, defaultItemValues, handleChangeValue, item.id, dbVal]);

  return (
    <HbHorizontalSelect
      itemId={item.id}
      currentValue={dbVal}
      descriptions={item.itemCodesHorizontalDescription}
      disabled={disabled}
      fontSize={fontSize}
      optionsItems={item?.itemCode?.codes?.map(({ dbVal, uiVal, calcVal }) => ({
        value: dbVal,
        label: uiVal,
        calcValue: calcVal,
      }))}
      onChangeValue={handleChangeValue}
    />
  );
}
